/* eslint-disable camelcase */
import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import "./DefaultForm.css";
import Cookies from "js-cookie";
import { Accordion, Col, Row, Form } from "react-bootstrap";
import { SingleCalendar } from "../../../../components";
import { useTranslation } from '../../../../contexts/TranslationContext';



/* ─────────────────────────  Component  ───────────────────────── */
const DefaultForm = forwardRef(({url, onChange = () => {}, showErrors = false, initialData = null,selectedDates }, ref) => {


  const Lang = Cookies.get("preferred_language") || "en";
  const [activeAccordionKeys, setActiveAccordionKeys] = useState(['0']);
  const { t } = useTranslation();

  const fieldToAccordionMap = {
    start_date: '0',
    end_date: '0',
  };

  /* -------------------------------- state -------------------------------- */
  const [form, setForm] = useState({
    start_date: null, end_date: null
  });

  const [errors, setErrors] = useState({});




  /* -------------------------------- validation -------------------------------- */
  const required = {

    start_date: t("StartDateRequired"),
    end_date: t("EndDateRequired"),
  };



  const rangeErr = {
    service: t("EndDateAfterStartDate"),
  };

  const validate = () => {
    const errs = {};

    /* mandatory scalar fields */
    Object.entries(required).forEach(([k, msg]) => {
      if (!form[k] || (typeof form[k] === "string" && !form[k].trim()))
        errs[k] = msg;
    });


    /* date ranges */
    if (form.start_date && form.end_date &&
      new Date(form.start_date) > new Date(form.end_date))
      errs.end_date = rangeErr.service;


    setErrors(errs);
    return !Object.keys(errs).length;
  };

  /* notify parent on every form change */
  useEffect(() => {
      onChange(form, validate());
  
    },[form]); // eslint-disable-line react-hooks/exhaustive-deps

  /* -------------------------------- helpers -------------------------------- */


  const err = (f) => showErrors && errors[f];

  /* -------------------------------- initialData ↩︎→ form -------------------------------- */
  useEffect(() => {

    if (!initialData || (initialData.start_date ===null && initialData.end_date === null) ) return;

    const toDate = (s) => (s ? new Date(s) : null);
    if(initialData.start_date !== form.start_date  || initialData.end_date !== form.end_date)
    {setForm({
      start_date: toDate(initialData.start_date),
      end_date: toDate(initialData.end_date),
    });

    onChange(initialData, true);}
    else {
      return
    }
  }, [initialData]);







  const scrollToFirstError = () => {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey) {
      // Expand accordion section containing the error
      const accordionKey = fieldToAccordionMap[firstErrorKey];
      if (accordionKey && !activeAccordionKeys.includes(accordionKey)) {
        setActiveAccordionKeys(prev => [...prev, accordionKey]);
      }

      // Scroll to field after accordion expands
      setTimeout(() => {
        const element = document.getElementById(`field-${firstErrorKey}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300); // Allow time for accordion to expand
    }
  };

  // Expose scroll method via ref
  useImperativeHandle(ref, () => ({
    scrollToFirstError
  }));

  // Auto-expand accordions when errors appear
  useEffect(() => {
    if (showErrors && Object.keys(errors).length > 0) {
      const errorAccordionKeys = Object.keys(errors)
        .map(field => fieldToAccordionMap[field])
        .filter(key => key !== undefined);

      setActiveAccordionKeys(prev => [
        ...prev,
        ...errorAccordionKeys.filter(key => !prev.includes(key))
      ]);
    }
  }, [showErrors, errors]);


  /* ======================= JSX ======================= */
  return (
    <Accordion
      className="hotel-form-accordion add-service-form-accordion services-visa-form-accordion-container"
      alwaysOpen
      activeKey={activeAccordionKeys}
      onSelect={(keys) => setActiveAccordionKeys(keys)}
    >
      {/* ---------------- 1. Personal ---------------- */}
      <Accordion.Item eventKey="0" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          1.{t("Dates")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
          <Col xl={4} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-expected_service"
              >
                <label className="hotel-form-input-label">
                  {t("StartDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.start_date}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, start_date: e.value }))
                  }
                  placeholder= {t("StartDate")}
                  min={new Date(selectedDates.startDate)}
                  max={
                      form.end_date
                        ? new Date(
                            Math.min(
                              new Date(form.end_date).getTime(),
                              new Date(selectedDates.endDate).getTime()
                            )
                          )
                        : new Date(selectedDates.endDate)
                    }
                  viewDate={new Date(selectedDates.startDate)}
                />
                {err("start_date") && (
                  <div className="field-error">{errors.start_date}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-expected_return"
              >
                <label className="hotel-form-input-label">
                  {t("EndDate")}
                  <span>*</span>
                </label>
                <SingleCalendar
                  value={form.end_date}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, end_date: e.value }))
                  }
                  placeholder={t("EndDate")}
                  min={
                      form.start_date
                        ? new Date(
                            Math.max(
                              new Date(form.start_date).getTime(),
                              new Date(selectedDates.startDate).getTime()
                            )
                          )
                        : new Date(selectedDates.startDate)
                    }
                  max={new Date(selectedDates.endDate)}
                  viewDate={new Date(selectedDates.endDate)}
                />
                {err("end_date") && (
                  <div className="field-error">{errors.end_date}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
});

export default DefaultForm;